<template>
  <div v-if="object">
    <div class="row text-white" :style="object.archivedDate ? 'background: #343a40' : 'background: #00bbff'">
      <div class="col-md-10" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>{{item.object.name + ' (ИНН: ' + fieldView(item.object.inn) + ', СНИЛС: ' + fieldView(item.object.snils) + ')'}}</b>
      </div>
      <div class="col-md-2" style="text-align: right">
        <i v-if="!inSave && !object.archivedDate" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
        <b v-else-if="object.archivedDate">В АРХИВЕ</b>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <base-input label="Ф.И.О."
                    v-model="object.name"
                    :placeholder="object.name">
        </base-input>
        <div class="row">
          <div class="col-md-6">
            <base-input label="Дата рождения"
                        v-model="object.birthdate"
                        :value="object.birthdate"
                        :date="true"
            ></base-input>
          </div>
          <div class="col-md-6">
            <slot name="label">
              <label class="control-label">
                Пол
              </label>
            </slot>
            <br/>
            <slot>
              <select name="onpage" v-model="object.sex">
                <option v-for="(sex, index) in sexArray" :key="index" :value="sex.value">{{ sex.name }}</option>
              </select>
            </slot>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <base-input label="ИНН"
                    v-model="object.inn"
                    placeholder="ИНН">
        </base-input>
        <base-input label="СНИЛС"
                    v-model="object.snils"
                    placeholder="СНИЛС">
        </base-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <base-input label="Адрес"
                    v-model="object.contact.address"
                    :placeholder="'Адрес'">
        </base-input>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-6">
            <base-input label="Телефон"
                        v-model="object.contact.phone"
                        :placeholder="'Телефон'">
            </base-input>
          </div>
          <div class="col-md-6">
            <base-input label="Электронная почта"
                        v-model="object.contact.email"
                        :placeholder="'e-mail'">
            </base-input>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <base-input label="Паспортные данные"
                    v-model="object.passport"
                    :placeholder="'Паспорт'">
        </base-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-5">
            <items-option :label="'Категория инвалидности'" :object="object.disabledCategory" @update="setDC" :type="'disabledCategory'">
            </items-option>
          </div>
          <div class="col-md-6">
            <items-option :label="'Группа'" :object="object.group" @update="setGroup" :type="'group'">
            </items-option>
          </div>
        </div>
      </div>
      <div class="col-md-6">
      </div>
    </div>

    <div v-if="!object.archivedDate" class="row" style="padding-bottom: 15px">
      <div class="col-md-12" style="text-align: right">
        <base-button @click="toArchive" :size="'sm'" type="warning" fill>В архив</base-button>
      </div>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {longAsStringDate} from "@/services/utils";
 import {authHeader} from "@/services/auth-header";

 export default {
   components: {
     SimpleRow,
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       socket: null,
       object: null,
       inSave: false,
       sexArray: [{name: 'М', value: 'MALE'}, {name: 'Ж', value: 'FEMALE'}, {name: 'нет данных', value: 'UNKNOWN'}]
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
       this.inSave = true;
       try {
         let renewed = await this.$repo.save(this.object, this.type);
         if (renewed) {
           this.item.object = renewed;
           this.item.id = renewed.id;
           this.object = JSON.parse(JSON.stringify(renewed));
           this.inSave = false;
           this.toView();
         }
       } catch(error) {
         this.inSave = false;
       }
     },
     setGroup(value) {
       this.object.group = value;
     },
     setDC(value) {
       this.object.disabledCategory = value;
     },
     async toArchive() {
       if (window.confirm('Переместить ' + this.object.name + ' ' + longAsStringDate(this.object.birthdate) + ' в архив?')) {
         this.sleep(1000);
         if(window.confirm('Точно переместить? Операция не обратима')) {
           this.inSave = true;
           try {
             let renewed = await this.$repo.deleteObject(this.object, 'client');
             if (renewed) {
               this.item.object = renewed;
               this.item.id = renewed.id;
               this.object = JSON.parse(JSON.stringify(renewed));
               this.inSave = false;
               this.toView();
             }
           } catch(error) {
             this.inSave = false;
           }
         }
       }
     },
     sleep(milliseconds) {
       const date = Date.now();
       let currentDate = null;
       do {
         currentDate = Date.now();
       } while (currentDate - date < milliseconds);
     }
   },
   mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
   }
 }
</script>
